import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { BasicButton } from '../../commons/buttons/BasicButton/BasicButton';
import { GlobalRouteNames } from '../../../models/Common';
import { handleMainBannerAnalytics } from '../../../utils';
import { ReactComponent as ArrowDown } from '../../../assets/images/arrows/ArrowDefault.svg';

export const NewOffersPromo: FC = () => {
  const { t } = useTranslation();
  const history = useHistory();

  const handleClick = () => {
    handleMainBannerAnalytics();
    history.push(GlobalRouteNames.OffersForYou);
  };

  return (
    <BasicButton className="service-cards-container__offers-banner" handleClick={handleClick}>
      <div className="service-cards-container__offers-banner__shadow">
        <div className="service-cards-container__offers-banner__inner">
          <div className="service-cards-container__offers-banner__title">{t('newOffers.weHaveNewOffersForYou')}</div>
          <div className="service-cards-container__offers-banner__description">
            {t('newOffers.check')} <ArrowDown />
          </div>
        </div>
      </div>
    </BasicButton>
  );
};
